export const initSwitchBtn = () => {
  const switchers = document.querySelectorAll(".switch-btn");

  switchers.forEach((switcher) => {
    switcher.addEventListener("click", () => {
      switcher.classList.toggle("switch-on");

      if (switcher.classList.contains("tariffsSection__switch-btn")) {
        switchTariffPeriod(switcher);
      }
    });
  });
};

export const switchTariffPeriod = (switcher) => {
  const isSwitched = switcher.classList.contains("switch-on");

  const tariffs = document.querySelectorAll(".tariffsSection__tariff");

  if (!tariffs.length) return;

  tariffs.forEach((tariff) => {
    const monthBlock = tariff.querySelector(".tariffsSection__toggleMonth");
    const yearBlock = tariff.querySelector(".tariffsSection__toggleYear");

    if (isSwitched) {
      monthBlock.style.display = "none";
      yearBlock.style.display = "flex";
    } else {
      monthBlock.style.display = "flex";
      yearBlock.style.display = "none";
    }
  });
};
